import * as React from "react";
import icon from "../../../UI/general/Icono.svg";
import POI from "../../../UI/general/PDI.svg";
import VIA from "../../../UI/general/Vias.svg";
import IIMG from "../../../UI/general/Image.svg";
import WORLD from "../../../UI/general/world.svg";
import { log } from "aframe";
import {
  FormControl,
  FormControlLabel,
  InputBase,
  InputLabel,
  NativeSelect,
  Switch,
  SwitchProps,
  styled,
} from "@mui/material";
import { rotate } from "ol/transform";
declare const window: any;

const SwitchDisponible = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 36,
  height: 20,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#65C466",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.mode === "dark" ? "#2ECA45" : "#C6C6C6",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #65C466",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 16,
    height: 16,
  },
  "& .MuiSwitch-track": {
    borderRadius: 20 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));
const SwitchNoDisponible = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 36,
  height: 20,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#000",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.mode === "dark" ? "#2ECA45" : "#C6C6C6",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #000",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 16,
    height: 16,
  },
  "& .MuiSwitch-track": {
    borderRadius: 20 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));
const SwitchVendido = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 36,
  height: 20,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#FF0000",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.mode === "dark" ? "#2ECA45" : "#C6C6C6",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #FF0000",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 16,
    height: 16,
  },
  "& .MuiSwitch-track": {
    borderRadius: 20 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));
const SwitchReservado = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 36,
  height: 20,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#EEA63A",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.mode === "dark" ? "#2ECA45" : "#C6C6C6",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #EEA63A",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 16,
    height: 16,
  },
  "& .MuiSwitch-track": {
    borderRadius: 20 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

/* const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "& .MuiInputBase-input": {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 12,
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:focus": {
      borderRadius: 4,
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
    },
  },
})); */

export default function SideBarContainer({
  data,
  setIsMapRender,
  isMapRender,
  isPortrait,
  setIsSelectedPOI,
  setIsSelectedVIA,
  isSelectedPOI,
  isSelectedVIA,
  original,
  setSpinSelected,
  setGaleriaSelected,
  setOriginalGleriaSelected,
  setSubMenuSelected,
  subMenuSelectedTemp,
  setMenuSelected,
  subMenuSelected,
  theme,
  isSideBar,
  setIsSideBar,
  menuSelected,
  icono,
  isSelected,
  setIsSelected,
  isSelectedAmenitiesAttributes,
  setIsSelectedAmenitiesAttributes,
  colors,
  setIsSelectedAttribute,
  setCurrentSelectedAttribute,
  isSelectedAttribute,
  setSelectAvailability,
  selectAvailability,
  setFrame,
  setIsAnimationAmenites,
  amenities_hierarchical,
  setIsAnimationAttribute
}: any) {
  const [isSelectedGallerieGroup, setIsSelectedGallerieGroup] =
    React.useState("");
  const [isSelectedLocationGroup, setIsSelectedLocationGroup] =
    React.useState("");
  const [isSelectedPropertiesGroup, setIsSelectedPropertiesGroup] =
    React.useState("");
  const [isDragging, setIsDragging] = React.useState(false);
  const [startX, setStartX] = React.useState(0);
  const [startXOther, setStartXOther]: any = React.useState(0);
  const [isSelectedModulAttribute, setIsSelectedModulAttribute]: any =
    React.useState({
      disponibilidad: true,
      filtros: true,
    });
    const [isSelectedAmenityAttributeIndividual, setIsSelectedAmenityAttributeIndividual]: any = React.useState("")

  /* const [age, setAge] = React.useState("");
  const handleChange = (event: { target: { value: string } }) => {
    setAge(event.target.value);
  }; */

  const handleAddDown = (val) => {
    var sidebarOriginal: any = document.querySelector(
      ".sidebar-container-portrait"
    );
    if (val) {
      sidebarOriginal.classList.remove("down");
      sidebarOriginal.classList.add("animation");
    } else {
      sidebarOriginal.classList.remove("animation");
      sidebarOriginal.classList.add("down");
    }
    var sidebar: any = document.querySelector(
      ".sidebar-container-portrait.down"
    );
    var sidebarInternal: any = document.querySelector(
      ".sidebar-container-portrait-internal"
    );

    if (sidebar) {
      if (
        (Array.isArray(data) && data.find((e) => e.id === isSelected))?.id ||
        (original && original.find((e) => e.name === isSelectedGallerieGroup))
          ?.name ||
        isSelectedLocationGroup !== ""
      ) {
        sidebar.style.bottom = -sidebarInternal.offsetHeight + 14 + "px";
      } else if (menuSelected === "Inmuebles") {
        sidebar.style.bottom = -sidebarInternal.offsetHeight + 14 + "px";
      } else {
        sidebar.style.bottom = -sidebarInternal.offsetHeight + 14 + "px";
      }
    } else {
      sidebarOriginal.style.removeProperty("bottom");
    }
  };

  React.useEffect(() => {
    if (menuSelected === "Inmuebles" && subMenuSelected !== "Galería") {
      let temp = {};
      data?.properties?.attributes?.forEach((element) => {
        if (element.active && element.name) {
          // Inicializa temp[element.name] como un objeto vacío si aún no se ha inicializado.
          if (!temp[element.name]) {
            //console.log(element);
            temp[element.name] =
              element?.values?.find(
                (e) =>
                  e.value ===
                  subMenuSelected
                    .replace(/\d+/g, (match: any) => ` ${match} `)
                    .split(/(?=[A-Z])/)
                    .join(" ")
                    .trimEnd()
              ) !== undefined
                ? element?.values?.find(
                  (e) =>
                    e.value ===
                    subMenuSelected
                      .replace(/\d+/g, (match: any) => ` ${match} `)
                      .split(/(?=[A-Z])/)
                      .join(" ")
                      .trimEnd()
                )
                : {};
          }
          // Aquí puedes agregar más lógica para configurar temp[element.name] según sea necesario.
        }
      });
      setIsSelectedAttribute(temp);
    }
  }, [menuSelected]);

  const isValidateFilter = (AtValue) => {
    let isValid = false;
    let indc = 0;
    const selectedKeys = Object.keys(isSelectedAttribute);

    for (let key of selectedKeys) {
      const atSelected = isSelectedAttribute[key];

      if (
        atSelected &&
        typeof atSelected === "object" &&
        Object.keys(atSelected).length > 0
      ) {
        for (let element of data?.properties?.property || []) {
          const valuesAP = element.values.find(
            (v) => v.IdValue === atSelected.id
          );

          if (valuesAP && Object.keys(valuesAP).length > 0) {
            if (element.values.some((v) => v.IdValue === AtValue.id)) {
              isValid = true;
              break; // Break the inner loop
            }
          }
        }
      } else {
        indc++;
      }

      if (selectedKeys.length === indc) {
        isValid = true;
      }

      if (isValid) break; // Break the outer loop if true has been set
    }

    return isValid;
  };

  const isValidateFilterAttribute = (AtValue) => {
    let isValid = false;
    const normalizedSubMenuSelected = subMenuSelected
      .replace(/\d+/g, (match) => ` ${match} `)
      .split(/(?=[A-Z])/)
      .join(" ")
      .trimEnd();

    for (let element of data?.properties?.property || []) {
      const valuesAP = element.values.find((v) => v.value === AtValue.value);
      const valuesAP2 = element.values.find(
        (v) => v.value === normalizedSubMenuSelected
      );

      if (
        valuesAP &&
        valuesAP2 &&
        Object.keys(valuesAP).length > 0 &&
        Object.keys(valuesAP2).length > 0
      ) {
        if (
          element.values.some((v) => v.value === AtValue.value) &&
          element.values.some((v) => v.value === normalizedSubMenuSelected)
        ) {
          isValid = true;
          break; // Break the loop if true has been set
        }
      }
    }

    return isValid;
  };

  const darkenColor = (color, percent) => {
    const f = parseInt(color.slice(1), 16);
    const t = percent < 0 ? 0 : 255;
    const p = percent < 0 ? percent * -1 : percent;
    const R = f >> 16;
    const G = (f >> 8) & 0x00ff;
    const B = f & 0x0000ff;
    return (
      "#" +
      (
        0x1000000 +
        (Math.round((t - R) * p) + R) * 0x10000 +
        (Math.round((t - G) * p) + G) * 0x100 +
        (Math.round((t - B) * p) + B)
      )
        .toString(16)
        .slice(1)
    );
  };

  // Calcular validaciones con useMemo fuera del mapeo
  const memoizedValidations = React.useMemo(() => {
    if (!data?.properties?.attributes) return [];

    return data.properties.attributes.map((row) => {
      return {
        row,
        validations: row?.values?.map((subRow) => ({
          subRow,
          isValidFilter: isValidateFilter(subRow),
          isValidFilterAttribute: isValidateFilterAttribute(subRow),
        })),
      };
    });
  }, [data, isSelectedAttribute, subMenuSelected]);

  const getButtonStyle = (
    row,
    subRow,
    subInd,
    colors,
    isSelectedAttribute,
    isValid
  ) => {
    const isSelected = isSelectedAttribute[row.name]?.value === subRow.value;
    const isMobile =
      !window.functionIsPortrait() && window.functionIsMobileDevice();

    let style: any = {
      backgroundColor: isSelected ? colors?.main_buttons : "",
      color: isSelected ? "#fff" : "",
      pointerEvents: isValid ? "auto" : "none",
      opacity: isValid ? "1" : "0.5",
      cursor: isValid ? "pointer" : "none",
    };

    if (subRow.value.length < 3) {
      style = {
        ...style,
        maxWidth: isMobile ? "1.5625rem" : "2.5rem",
        width: isMobile ? "1.5625rem" : "2.5rem",
        height: isMobile ? "1.0625rem" : "1.875rem",
        maxHeight: isMobile ? "1.0625rem" : "1.875rem",
        marginLeft: isMobile ? "0.375rem" : "0.625rem",
        marginRight:
          isMobile && subInd === row?.values?.length
            ? "0.375rem !important"
            : "",
      };
    } else if (subRow.value.length < 12) {
      style = {
        ...style,
        maxWidth: isMobile ? "3.5625rem" : "5.625rem",
        width: isMobile ? "3.5625rem" : "5.625rem",
        height: isMobile ? "1.0625rem" : "1.875rem",
        maxHeight: isMobile ? "1.0625rem" : "1.875rem",
        marginLeft: isMobile ? "0.375rem" : "0.625rem",
        marginRight:
          isMobile && subInd === row?.values?.length
            ? "0.375rem !important"
            : "",
      };
    } else {
      style = {
        ...style,
        maxWidth: isMobile ? "3.5625rem" : "11.8125rem",
        width: isMobile ? "3.5625rem" : "11.8125rem",
        height: isMobile ? "1.0625rem" : "1.875rem",
        maxHeight: isMobile ? "1.0625rem" : "1.875rem",
        marginLeft: isMobile ? "0.375rem" : "0.625rem",
        marginRight:
          isMobile && subInd === row?.values?.length
            ? "0.375rem !important"
            : "",
      };
    }

    return style;
  };
  //console.log(data?.properties?.attributes);
  //console.log(isSelectedAttribute);

  /* console.log(menuSelected);
  console.log(subMenuSelected);
  console.log(subMenuSelectedTemp); */
  
  return !isPortrait ? (
    <div className={`sidebar-container ${isSideBar ? "show" : ""}`}>
      <div className={`sidebar-internal-container ${theme} ${menuSelected}`}>
        <div className="sidebar-internal-container-close">
          <div
            className="setting-boton-circular"
            onClick={() => {
              setGaleriaSelected([]);

              if (
                menuSelected === "Inmuebles" &&
                subMenuSelected === "Galería"
              ) {
                setSubMenuSelected(subMenuSelectedTemp);
              } else if (
                menuSelected !== "Galería" &&
                menuSelected !== "Inmuebles" &&
                subMenuSelected === "Galería"
              ) {
                setSubMenuSelected("");
              } else {
                setMenuSelected("");
                setSubMenuSelected("");
              }

              // setFrame(1);
            }}
          >
            <i className="fas fa-xmark"></i>
          </div>
        </div>
        <div className="sidebar-internal-container-logo">
          <img src={icono} alt="" />
          <div className="sidebar-internal-container-title">
            {subMenuSelected === "Galería" ? subMenuSelected : menuSelected}
          </div>
        </div>
        <div></div>
        {menuSelected === "Galería" &&
          subMenuSelected !== "" &&
          subMenuSelected !== "Galería" ? (
          <div className="sidebar-internal-container-breadcrum">
            <div
              className="sidebar-internal-container-breadcrum-inactive"
              onClick={() => {
                setIsSelected("");
                setSubMenuSelected("Galería");
                setGaleriaSelected(original);
              }}
            >
              {menuSelected}
            </div>{" "}
            <i className="fa-solid fa-caret-right"></i>{" "}
            <div
              className="sidebar-internal-container-breadcrum-active"
              style={{ backgroundColor: colors?.main_buttons }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = darkenColor(
                  colors?.main_buttons,
                  -0.2
                );
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = colors?.main_buttons;
              }}
            >
              {subMenuSelected}
            </div>
          </div>
        ) : null}
        {menuSelected !== "Galería" && subMenuSelected === "Galería" ? (
          <div>{`/${menuSelected}`}</div>
        ) : null}
        <div
          className={`sidebar-internal-container-menus ${menuSelected === "Galería" && subMenuSelected === "Galería"
            ? "folder"
            : ""
            }`}
        >
          {menuSelected === "Urbanismo" && subMenuSelected === "" ? (
            data
              .sort((a, b) =>
                !a.hierarchicalLevel
                  ? 1
                  : !b.hierarchicalLevel
                    ? -1
                    : parseInt(b.hierarchicalLevel.split("#")[1]) -
                    parseInt(a.hierarchicalLevel.split("#")[1])
              )
              ?.map((row) =>
                row.type === "Hierarchical" ? (
                  <div
                    className="sidebar-internal-container-menus-item"
                    onClick={() =>
                      setIsSelected(isSelected === row.name ? "" : row.name)
                    }
                    style={
                      isSelected === row.name
                        ? {
                          backgroundColor: colors?.main_buttons,
                          color: "#fff",
                        }
                        : {}
                    }
                    data-type={"URBANISMO"}
                    data-value={row.name.toUpperCase()}
                  >
                    <div
                      style={
                        isSelected === row.name
                          ? {
                            backgroundColor: colors?.main_buttons,
                            color: "#fff",
                          }
                          : {}
                      }
                      data-type={"URBANISMO"}
                      data-value={row.name.toUpperCase()}
                    >
                      <img
                        src={icon}
                        alt=""
                        data-type={"URBANISMO"}
                        data-value={row.name.toUpperCase()}
                        style={
                          isSelected === row.name
                            ? {
                              filter: "invert(1) brightness(100%)",
                            }
                            : {}
                        }
                      />{" "}
                      {row.name}
                    </div>
                  </div>
                ) : null
              )
          ) : menuSelected === "Ubicación" ? (
            <>
              {data?.routes?.length > 0 ||
                data?.mapa_ilustrado_vias !== null ? (
                <div className="sidebar-internal-container-options-location">
                  <div className="sidebar-internal-container-options-location-title">
                    <img src={VIA} alt="" />
                    Vías de Acceso
                  </div>
                  {data?.mapa_ilustrado_vias !== null ||
                    data?.mapa_vias_foto_360 ? (
                    <div className="sidebar-internal-container-options-location-adicional">
                      <div className="sidebar-internal-container-options-location-adicional-title">
                        INFORMACIÓN ADICIONAL
                      </div>
                      {data?.mapa_vias_foto_360 ? (
                        <div className="sidebar-internal-container-options-location-adicional-item">
                          <img src={WORLD} alt="" />
                          Foto aérea 360°
                        </div>
                      ) : null}
                      {data?.mapa_ilustrado_vias !== null ? (
                        <div
                          className="sidebar-internal-container-options-location-adicional-item"
                          style={
                            isMapRender
                              ? {
                                backgroundColor: colors?.main_buttons,
                                color: "#fff",
                              }
                              : {}
                          }
                          onClick={() => {
                            setIsMapRender(!isMapRender),
                              setIsSelectedVIA([]),
                              setIsSelectedPOI([]);
                          }}
                        >
                          <img src={IIMG} alt="" />
                          Mapa ilustrado
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                  <div
                    className="sidebar-internal-container-options-location-poi"
                    onClick={() => {
                      setIsSelectedVIA(data?.routes),
                        setIsSelectedPOI([]),
                        setIsMapRender(false);
                    }}
                    style={
                      isSelectedVIA.length > 1
                        ? {
                          backgroundColor: colors?.main_buttons,
                          color: "#fff",
                        }
                        : {}
                    }
                  >
                    <img
                      src={icon}
                      style={
                        isSelectedVIA.length > 1
                          ? { filter: "invert(1) brightness(100%)" }
                          : {}
                      }
                      alt=""
                    />
                    <span>Ver todos</span>
                  </div>
                  {data?.routes?.length > 0
                    ? data?.routes?.map((e) => (
                      <div
                        className="sidebar-internal-container-options-location-poi"
                        style={
                          isSelectedVIA.length === 1 &&
                            isSelectedVIA[0]?.name === e.name
                            ? {
                              backgroundColor: colors?.main_buttons,
                              color: "#fff",
                            }
                            : {}
                        }
                        onClick={() => {
                          setIsSelectedVIA(
                            isSelectedVIA.length === 1 &&
                              isSelectedVIA[0]?.name === e.name
                              ? []
                              : [e]
                          ),
                            setIsSelectedPOI([]);
                          setIsMapRender(false);
                        }}
                        data-type={"UBICACION"}
                        data-value={"VIA"}
                        data-second={e.name.toUpperCase()}
                      >
                        <div
                          style={{ backgroundColor: e.color }}
                          data-type={"UBICACION"}
                          data-value={"VIA"}
                          data-second={e.name.toUpperCase()}
                        ></div>
                        <span
                          data-type={"UBICACION"}
                          data-value={"VIA"}
                          data-second={e.name.toUpperCase()}
                        >
                          {e.name}
                        </span>
                      </div>
                    ))
                    : null}
                </div>
              ) : null}
              {data?.POIS?.length > 0 || data?.mapa_ilustrado_pois !== null ? (
                <div className="sidebar-internal-container-options-location">
                  <div className="sidebar-internal-container-options-location-title">
                    <img src={POI} alt="" />
                    Puntos de interés
                  </div>
                  {data?.mapa_ilustrado_pois !== null ||
                    data?.mapa_pois_foto_360 ? (
                    <div className="sidebar-internal-container-options-location-adicional">
                      <div className="sidebar-internal-container-options-location-adicional-title">
                        INFORMACIÓN ADICIONAL
                      </div>
                      {data?.mapa_vias_foto_360 ? (
                        <div className="sidebar-internal-container-options-location-adicional-item">
                          <img src={WORLD} alt="" />
                          Foto aérea 360°
                        </div>
                      ) : null}
                      {data?.mapa_ilustrado_vias !== null ? (
                        <div className="sidebar-internal-container-options-location-adicional-item">
                          <img src={IIMG} alt="" />
                          Mapa ilustrado
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                  <div
                    className="sidebar-internal-container-options-location-poi"
                    onClick={() => {
                      setIsSelectedPOI(
                        isSelectedPOI.length.length > 0 ? [] : data?.POIS
                      ),
                        setIsSelectedVIA([]);
                      setIsMapRender(false);
                    }}
                    style={
                      isSelectedPOI.length > 1
                        ? {
                          backgroundColor: colors?.main_buttons,
                          color: "#fff",
                        }
                        : {}
                    }
                  >
                    <img
                      src={icon}
                      style={
                        isSelectedPOI.length > 1
                          ? { filter: "invert(1) brightness(100%)" }
                          : {}
                      }
                      alt=""
                    />
                    <span>Ver todos</span>
                  </div>
                  {data?.POIS?.length > 0
                    ? data?.POIS?.map((e) => (
                      <div
                        className="sidebar-internal-container-options-location-poi"
                        style={
                          isSelectedPOI.length === 1 &&
                            isSelectedPOI[0]?.category === e.category
                            ? {
                              backgroundColor: colors?.main_buttons,
                              color: "#fff",
                            }
                            : {}
                        }
                        onClick={() => {
                          setIsSelectedPOI(
                            isSelectedPOI.length === 1 &&
                              isSelectedPOI[0]?.category === e.category
                              ? []
                              : [e]
                          ),
                            setIsSelectedVIA([]);
                          setIsMapRender(false);
                        }}
                        data-type={"UBICACION"}
                        data-value={"POI"}
                        data-second={e.category.toUpperCase()}
                      >
                        <img
                          style={
                            isSelectedPOI.length === 1 &&
                              isSelectedPOI[0]?.category === e.category
                              ? { filter: "invert(1) brightness(100%)" }
                              : {}
                          }
                          src={
                            (window.hybrid
                              ? "./"
                              : "https://d1bsymnertnea6.cloudfront.net/") +
                            e.icon
                          }
                          data-type={"UBICACION"}
                          data-value={"POI"}
                          data-second={e.category.toUpperCase()}
                        />
                        <span
                          data-type={"UBICACION"}
                          data-value={"POI"}
                          data-second={e.category.toUpperCase()}
                        >
                          {e.category}
                        </span>
                      </div>
                    ))
                    : null}
                </div>
              ) : null}
            </>
          ) : menuSelected === "Inmuebles" && subMenuSelected === "" ? (
            <>
              {data?.properties?.disponibilidad ? (
                <div
                  className={`sidebar-internal-container-menus-availability ${isSelectedModulAttribute.disponibilidad ? "" : "collapse"
                    }`}
                >
                  <div
                    className="sidebar-internal-container-menus-availability-title"
                    onClick={() =>
                      setIsSelectedModulAttribute({
                        ...isSelectedModulAttribute,
                        disponibilidad:
                          !isSelectedModulAttribute.disponibilidad,
                      })
                    }
                  >
                    DISPONIBILIDAD
                    <i
                      style={{
                        transform: isSelectedModulAttribute.disponibilidad
                          ? "rotate(90deg)"
                          : "rotate(0deg)",
                      }}
                      className={`fa fa-chevron-right`}
                    ></i>
                  </div>
                  {/* {isSelectedModulAttribute.disponibilidad ? (
                    <> */}
                  {data?.state_disponible ? (
                    <div className="sidebar-internal-container-menus-availability-sw">
                      <FormControlLabel
                        control={
                          <SwitchDisponible sx={{ m: 0.5 }} defaultChecked />
                        }
                        label=""
                        style={{ marginLeft: "0.2rem" }}
                        onChange={(e: any) =>
                          setSelectAvailability({
                            ...selectAvailability,
                            DISPONIBLE: e.target.checked,
                          })
                        }
                      />
                      <span>Disponible</span>
                    </div>
                  ) : null}{" "}
                  {data?.state_vendido === 1 ? (
                    <div className="sidebar-internal-container-menus-availability-sw">
                      <FormControlLabel
                        control={
                          <SwitchVendido sx={{ m: 0.5 }} defaultChecked />
                        }
                        label=""
                        style={{ marginLeft: "0.2rem" }}
                        onChange={(e: any) =>
                          setSelectAvailability({
                            ...selectAvailability,
                            VENDIDO: e.target.checked,
                          })
                        }
                      />
                      <span>Vendido</span>
                    </div>
                  ) : null}{" "}
                  {data?.state_no_disponible ? (
                    <div className="sidebar-internal-container-menus-availability-sw">
                      <FormControlLabel
                        control={
                          <SwitchNoDisponible sx={{ m: 0.5 }} defaultChecked />
                        }
                        label=""
                        style={{ marginLeft: "0.2rem" }}
                        onChange={(e: any) =>
                          setSelectAvailability({
                            ...selectAvailability,
                            "NO DISPONIBLE": e.target.checked,
                          })
                        }
                      />
                      <span>No Disponible</span>
                    </div>
                  ) : null}{" "}
                  {data?.state_reservado === 1 ? (
                    <div className="sidebar-internal-container-menus-availability-sw">
                      <FormControlLabel
                        control={
                          <SwitchReservado sx={{ m: 0.5 }} defaultChecked />
                        }
                        label=""
                        style={{ marginLeft: "0.2rem" }}
                        onChange={(e: any) =>
                          setSelectAvailability({
                            ...selectAvailability,
                            RESERVADO: e.target.checked,
                          })
                        }
                      />
                      <span>Reservado</span>
                    </div>
                  ) : null}
                  {/* </>
                  ) : null} */}
                </div>
              ) : null}
              <div
                className={`sidebar-internal-container-menus-attributes ${isSelectedModulAttribute.filtros ? "" : "collapse"
                  }`}
              >
                <div
                  className="sidebar-internal-container-menus-attributes-title"
                  onClick={() =>
                    setIsSelectedModulAttribute({
                      ...isSelectedModulAttribute,
                      filtros: !isSelectedModulAttribute.filtros,
                    })
                  }
                >
                  FILTRAR POR ATRIBUTOS
                  <i
                    style={{
                      transform: isSelectedModulAttribute.filtros
                        ? "rotate(90deg)"
                        : "rotate(0deg)",
                    }}
                    className={`fa fa-chevron-right`}
                  ></i>
                </div>
                {data?.properties?.attributes
                  .sort((a, b) =>
                    a.indice === null
                      ? 1
                      : b.indice === null
                        ? -1
                        : a.indice - b.indice
                  )
                  ?.map((row, ind) =>
                    row.active ? (
                      <div
                        className="sidebar-internal-container-menus-attributes-individual"
                        style={
                          isSelected === row.name
                            ? {
                              backgroundColor: colors?.main_buttons,
                              color: "#fff",
                            }
                            : {}
                        }
                      >
                        <div
                          style={{
                            marginBottom: "0.625rem",
                            marginTop: ind !== 0 ? "1.25rem" : "0rem",
                          }}
                        >
                          {row.name}
                        </div>
                        {/* {isSelectedAttribute === row.name ? ( */}
                        <div className="sidebar-internal-container-menus-attributes-individual-values">
                          <div
                            className="sidebar-internal-container-menus-attributes-individual-values-button"
                            style={{
                              maxWidth:
                                !window.functionIsPortrait() &&
                                  window.functionIsMobileDevice()
                                  ? "3.5625rem"
                                  : "5.625rem",
                              width:
                                !window.functionIsPortrait() &&
                                  window.functionIsMobileDevice()
                                  ? "3.5625rem"
                                  : "5.625rem",
                              height:
                                !window.functionIsPortrait() &&
                                  window.functionIsMobileDevice()
                                  ? "1.0625rem"
                                  : "1.875rem",
                              maxHeight:
                                !window.functionIsPortrait() &&
                                  window.functionIsMobileDevice()
                                  ? "1.0625rem"
                                  : "1.875rem",
                              marginLeft:
                                !window.functionIsPortrait() &&
                                  window.functionIsMobileDevice()
                                  ? "0.375rem"
                                  : "0.625rem",
                              backgroundColor:
                                (isSelectedAttribute[row.name] &&
                                  Object.keys(isSelectedAttribute[row.name])
                                    .length === 0) ||
                                  isSelectedAttribute[row.name] === undefined
                                  ? colors?.main_buttons
                                  : "",
                              color:
                                (isSelectedAttribute[row.name] &&
                                  Object.keys(isSelectedAttribute[row.name])
                                    .length === 0) ||
                                  isSelectedAttribute[row.name] === undefined
                                  ? "#fff"
                                  : "",
                            }}
                            onClick={() =>
                              {setIsSelectedAttribute({
                                ...isSelectedAttribute,
                                [row.name]: {},
                              })
                              setCurrentSelectedAttribute({})
                              setIsAnimationAttribute(true)
                            }
                            }
                          >
                            Ver todos
                          </div>
                          {row?.values?.map((subRow, subInd) => (
                            <div
                              className="sidebar-internal-container-menus-attributes-individual-values-button"
                              style={
                                subRow.value.length < 3
                                  ? {
                                    maxWidth:
                                      !window.functionIsPortrait() &&
                                        window.functionIsMobileDevice()
                                        ? "1.5625rem"
                                        : "2.5rem",
                                    width:
                                      !window.functionIsPortrait() &&
                                        window.functionIsMobileDevice()
                                        ? "1.5625rem"
                                        : "2.5rem",
                                    height:
                                      !window.functionIsPortrait() &&
                                        window.functionIsMobileDevice()
                                        ? "1.0625rem"
                                        : "1.875rem",
                                    maxHeight:
                                      !window.functionIsPortrait() &&
                                        window.functionIsMobileDevice()
                                        ? "1.0625rem"
                                        : "1.875rem",
                                    marginLeft:
                                      !window.functionIsPortrait() &&
                                        window.functionIsMobileDevice()
                                        ? "0.375rem"
                                        : "0.625rem",
                                    marginRight:
                                      subInd === row?.values?.length
                                        ? !window.functionIsPortrait() &&
                                          window.functionIsMobileDevice()
                                          ? "0.375rem !important"
                                          : "0.625rem"
                                        : "",
                                    backgroundColor:
                                      isSelectedAttribute[row.name]?.value ===
                                        subRow.value
                                        ? colors?.main_buttons
                                        : "",
                                    color:
                                      isSelectedAttribute[row.name]?.value ===
                                        subRow.value
                                        ? "#fff"
                                        : "",
                                    pointerEvents: isValidateFilter(subRow)
                                      ? "auto"
                                      : "none",
                                    opacity: isValidateFilter(subRow)
                                      ? "1"
                                      : "0.5",
                                    cursor: isValidateFilter(subRow)
                                      ? "pointer"
                                      : "none",
                                  }
                                  : subRow.value.length > 2 &&
                                    subRow.value.length < 12
                                    ? {
                                      maxWidth:
                                        !window.functionIsPortrait() &&
                                          window.functionIsMobileDevice()
                                          ? "3.5625rem"
                                          : "5.625rem",
                                      width:
                                        !window.functionIsPortrait() &&
                                          window.functionIsMobileDevice()
                                          ? "3.5625rem"
                                          : "5.625rem",
                                      height:
                                        !window.functionIsPortrait() &&
                                          window.functionIsMobileDevice()
                                          ? "1.0625rem"
                                          : "1.875rem",
                                      maxHeight:
                                        !window.functionIsPortrait() &&
                                          window.functionIsMobileDevice()
                                          ? "1.0625rem"
                                          : "1.875rem",
                                      marginLeft:
                                        !window.functionIsPortrait() &&
                                          window.functionIsMobileDevice()
                                          ? "0.375rem"
                                          : "0.625rem",
                                      marginRight:
                                        subInd === row?.values?.length
                                          ? !window.functionIsPortrait() &&
                                            window.functionIsMobileDevice()
                                            ? "0.375rem !important"
                                            : "0.625rem"
                                          : "",
                                      backgroundColor:
                                        isSelectedAttribute[row.name]?.value ===
                                          subRow.value
                                          ? colors?.main_buttons
                                          : "",
                                      color:
                                        isSelectedAttribute[row.name]?.value ===
                                          subRow.value
                                          ? "#fff"
                                          : "",
                                      pointerEvents: isValidateFilter(subRow)
                                        ? "auto"
                                        : "none",
                                      opacity: isValidateFilter(subRow)
                                        ? "1"
                                        : "0.5",
                                      cursor: isValidateFilter(subRow)
                                        ? "pointer"
                                        : "none",
                                    }
                                    : {
                                      maxWidth:
                                        !window.functionIsPortrait() &&
                                          window.functionIsMobileDevice()
                                          ? "3.5625rem"
                                          : "11.8125rem",
                                      width:
                                        !window.functionIsPortrait() &&
                                          window.functionIsMobileDevice()
                                          ? "3.5625rem"
                                          : "11.8125rem",
                                      height:
                                        !window.functionIsPortrait() &&
                                          window.functionIsMobileDevice()
                                          ? "1.0625rem"
                                          : "1.875rem",
                                      maxHeight:
                                        !window.functionIsPortrait() &&
                                          window.functionIsMobileDevice()
                                          ? "1.0625rem"
                                          : "1.875rem",
                                      marginLeft:
                                        !window.functionIsPortrait() &&
                                          window.functionIsMobileDevice()
                                          ? "0.375rem"
                                          : "0.625rem",
                                      marginRight:
                                        subInd === row?.values?.length
                                          ? !window.functionIsPortrait() &&
                                            window.functionIsMobileDevice()
                                            ? "0.375rem !important"
                                            : "0.625rem"
                                          : "",
                                      backgroundColor:
                                        isSelectedAttribute[row.name]?.value ===
                                          subRow.value
                                          ? colors?.main_buttons
                                          : "",
                                      color:
                                        isSelectedAttribute[row.name]?.value ===
                                          subRow.value
                                          ? "#fff"
                                          : "",
                                      pointerEvents: isValidateFilter(subRow)
                                        ? "auto"
                                        : "none",
                                      opacity: isValidateFilter(subRow)
                                        ? "1"
                                        : "0.5",
                                      cursor: isValidateFilter(subRow)
                                        ? "pointer"
                                        : "none",
                                    }
                              }
                              data-type={"FILTRO"}
                              data-value={row.name.toUpperCase()}
                              data-second={subRow.value.toUpperCase()}
                              onClick={() =>
                                {setIsSelectedAttribute({
                                  ...isSelectedAttribute,
                                  [row.name]: subRow,
                                })
                                setCurrentSelectedAttribute(subRow)
                                setIsAnimationAttribute(true)
                              }
                              }
                            >
                              {subRow.value}
                            </div>
                          ))}
                        </div>
                        {/* ) : null} */}
                      </div>
                    ) : null
                  )}
              </div>
            </>
          ) : menuSelected === "Inmuebles" &&
            subMenuSelected !== "" &&
            subMenuSelected !== "Galería" ? (
            <>
              {data?.properties?.disponibilidad ? (
                <div
                  className={`sidebar-internal-container-menus-availability ${isSelectedModulAttribute.disponibilidad ? "" : "collapse"
                    }`}
                >
                  <div
                    className="sidebar-internal-container-menus-availability-title"
                    onClick={() =>
                      setIsSelectedModulAttribute({
                        ...isSelectedModulAttribute,
                        disponibilidad:
                          !isSelectedModulAttribute.disponibilidad,
                      })
                    }
                  >
                    DISPONIBILIDAD
                    <i
                      style={{
                        transform: isSelectedModulAttribute.disponibilidad
                          ? "rotate(90deg)"
                          : "rotate(0deg)",
                      }}
                      className={`fa fa-chevron-right`}
                    ></i>
                  </div>
                  {isSelectedModulAttribute.disponibilidad ? (
                    <>
                      {data?.state_disponible ? (
                        <div className="sidebar-internal-container-menus-availability-sw">
                          <FormControlLabel
                            control={
                              <SwitchDisponible
                                sx={{ m: 0.5 }}
                                defaultChecked
                              />
                            }
                            label=""
                            style={{ marginLeft: "0.2rem" }}
                            onChange={(e: any) =>
                              setSelectAvailability({
                                ...selectAvailability,
                                DISPONIBLE: e.target.checked,
                              })
                            }
                          />
                          <span>Disponible</span>
                        </div>
                      ) : null}{" "}
                      {data?.state_vendido === 1 ? (
                        <div className="sidebar-internal-container-menus-availability-sw">
                          <FormControlLabel
                            control={
                              <SwitchVendido sx={{ m: 0.5 }} defaultChecked />
                            }
                            label=""
                            style={{ marginLeft: "0.2rem" }}
                            onChange={(e: any) =>
                              setSelectAvailability({
                                ...selectAvailability,
                                VENDIDO: e.target.checked,
                              })
                            }
                          />
                          <span>Vendido</span>
                        </div>
                      ) : null}{" "}
                      {data?.state_no_disponible ? (
                        <div className="sidebar-internal-container-menus-availability-sw">
                          <FormControlLabel
                            control={
                              <SwitchNoDisponible
                                sx={{ m: 0.5 }}
                                defaultChecked
                              />
                            }
                            label=""
                            style={{ marginLeft: "0.2rem" }}
                            onChange={(e: any) =>
                              setSelectAvailability({
                                ...selectAvailability,
                                "NO DISPONIBLE": e.target.checked,
                              })
                            }
                          />
                          <span>No Disponible</span>
                        </div>
                      ) : null}{" "}
                      {data?.state_reservado === 1 ? (
                        <div className="sidebar-internal-container-menus-availability-sw">
                          <FormControlLabel
                            control={
                              <SwitchReservado sx={{ m: 0.5 }} defaultChecked />
                            }
                            label=""
                            style={{ marginLeft: "0.2rem" }}
                            onChange={(e: any) =>
                              setSelectAvailability({
                                ...selectAvailability,
                                RESERVADO: e.target.checked,
                              })
                            }
                          />
                          <span>Reservado</span>
                        </div>
                      ) : null}
                    </>
                  ) : null}
                </div>
              ) : null}
              <div
                className={`sidebar-internal-container-menus-attributes ${isSelectedModulAttribute.filtros ? "" : "collapse"
                  }`}
              >
                <div
                  className="sidebar-internal-container-menus-attributes-title"
                  onClick={() =>
                    setIsSelectedModulAttribute({
                      ...isSelectedModulAttribute,
                      filtros: !isSelectedModulAttribute.filtros,
                    })
                  }
                >
                  FILTRAR POR ATRIBUTOS
                  <i
                    style={{
                      transform: isSelectedModulAttribute.filtros
                        ? "rotate(90deg)"
                        : "rotate(0deg)",
                    }}
                    className={`fa fa-chevron-right`}
                  ></i>
                </div>
                {isSelectedModulAttribute.filtros &&
                  memoizedValidations
                    .sort((a, b) =>
                      a.indice === null
                        ? 1
                        : b.indice === null
                          ? -1
                          : a.indice - b.indice
                    )
                    .map(({ row, validations }, ind) =>
                      row.active ? (
                        <div
                          key={row.name}
                          className="sidebar-internal-container-menus-attributes-individual"
                          style={
                            isSelected === row.name
                              ? {
                                backgroundColor: colors?.main_buttons,
                                color: "#fff",
                              }
                              : {}
                          }
                        >
                          <div
                            style={{
                              marginBottom: "0.625rem",
                              marginTop: ind !== 0 ? "1.25rem" : "0rem",
                            }}
                          >
                            {row.name}
                          </div>
                          <div className="sidebar-internal-container-menus-attributes-individual-values">
                            <div
                              className="sidebar-internal-container-menus-attributes-individual-values-button"
                              style={{
                                marginLeft: "0.625rem",
                                backgroundColor:
                                  (isSelectedAttribute[row.name] &&
                                    Object.keys(isSelectedAttribute[row.name])
                                      .length === 0) ||
                                    isSelectedAttribute[row.name] === undefined
                                    ? colors?.main_buttons
                                    : "",
                                color:
                                  (isSelectedAttribute[row.name] &&
                                    Object.keys(isSelectedAttribute[row.name])
                                      .length === 0) ||
                                    isSelectedAttribute[row.name] === undefined
                                    ? "#fff"
                                    : "",
                                pointerEvents:
                                  row.values.find(
                                    (e) =>
                                      e.value ===
                                      subMenuSelected
                                        .replace(
                                          /\d+/g,
                                          (match) => ` ${match} `
                                        )
                                        .split(/(?=[A-Z])/)
                                        .join(" ")
                                        .trimEnd()
                                  ) === undefined
                                    ? "auto"
                                    : "none",
                                opacity:
                                  row.values.find(
                                    (e) =>
                                      e.value ===
                                      subMenuSelected
                                        .replace(
                                          /\d+/g,
                                          (match) => ` ${match} `
                                        )
                                        .split(/(?=[A-Z])/)
                                        .join(" ")
                                        .trimEnd()
                                  ) === undefined
                                    ? "1"
                                    : "0.5",
                                cursor:
                                  row.values.find(
                                    (e) =>
                                      e.value ===
                                      subMenuSelected
                                        .replace(
                                          /\d+/g,
                                          (match) => ` ${match} `
                                        )
                                        .split(/(?=[A-Z])/)
                                        .join(" ")
                                        .trimEnd()
                                  ) === undefined
                                    ? "pointer"
                                    : "none",
                              }}
                              onClick={() =>
                                {setIsSelectedAttribute({
                                  ...isSelectedAttribute,
                                  [row.name]: {},
                                })
                                setCurrentSelectedAttribute({})
                                setIsAnimationAttribute(true)
                              }
                              }
                            >
                              Ver todos
                            </div>
                            {validations.map(
                              ({
                                subRow,
                                subInd,
                                isValidFilter,
                                isValidFilterAttribute,
                              }) => (
                                <div
                                  key={subRow.value}
                                  className="sidebar-internal-container-menus-attributes-individual-values-button"
                                  style={getButtonStyle(
                                    row,
                                    subRow,
                                    subInd,
                                    colors,
                                    isSelectedAttribute,
                                    isValidFilter && isValidFilterAttribute
                                  )}
                                  data-type="FILTRO"
                                  data-value={row.name.toUpperCase()}
                                  data-second={subRow.value.toUpperCase()}
                                  onClick={() =>
                                    {setIsSelectedAttribute({
                                      ...isSelectedAttribute,
                                      [row.name]: subRow,
                                    })
                                    setCurrentSelectedAttribute(subRow)
                                    setIsAnimationAttribute(true)
                                  }
                                  }
                                >
                                  {subRow.value}
                                </div>
                              )
                            )}
                          </div>
                        </div>
                      ) : null
                    )}
              </div>
            </>
          ) : menuSelected === "Amenidades" &&
            (subMenuSelected === "" || subMenuSelected === "Spin") && amenities_hierarchical === 1 ? (
            <>
              <div
                className="sidebar-internal-container-menus-item"
                onClick={() => {
                  setIsSelected("");
                  setSpinSelected([]);
                  setSubMenuSelected("");
                  setIsAnimationAmenites(true);
                  setIsSelectedAmenityAttributeIndividual("")
                  setIsSelectedAmenitiesAttributes([])
                }}
                style={
                  isSelected === ""
                    ? {
                      backgroundColor: colors?.main_buttons,
                      color: "#fff",
                    }
                    : {}
                }
              >
                <div
                  style={
                    isSelected === ""
                      ? {
                        backgroundColor: colors?.main_buttons,
                        color: "#fff",
                      }
                      : {}
                  }
                >
                  <img
                    src={icon}
                    alt=""
                    style={
                      isSelected === ""
                        ? {
                          filter: "invert(1) brightness(100%)",
                        }
                        : {}
                    }
                  />{" "}
                  {"Ver todos"}
                </div>
              </div>
              {data?.map((roww) => (
                <div className="sidebar-internal-container-menus-item-attribute">
                  <div
                  onClick={() => {
                    setIsSelectedAmenityAttributeIndividual(isSelectedAmenityAttributeIndividual === roww.attribute_id ? "" : roww.attribute_id),
                    setIsSelectedAmenitiesAttributes(isSelectedAmenityAttributeIndividual === roww.attribute_id ? [] : roww.amenities)
                  }}
                  style={{marginBottom: "10px"}}
                  >
                    <img
                      src={icon}
                      alt=""
                    />{" "}
                    {roww.attribute}
                    {roww.amenities.length > 0 ? (
                      <i
                        className={`fa fa-chevron-right`}
                        style={{
                          transform:
                            isSelectedAmenityAttributeIndividual === roww.id
                              ? "rotate(90deg)"
                              : "rotate(0deg)",
                        }}
                      ></i>
                    ) : null}
                  </div>
                  {isSelectedAmenityAttributeIndividual === roww.attribute_id && roww?.amenities?.map((row) => (
                    <div
                      className="sidebar-internal-container-menus-item"
                      onClick={() => {
                        setIsSelected(isSelected === row.id ? "" : row.id);
                        setSpinSelected([]);
                        setSubMenuSelected("");
                        setIsAnimationAmenites(true);
                        setIsSelectedAmenitiesAttributes([])
                      }}
                      style={
                        isSelected === row.id &&
                          row.menu.length === 0 &&
                          row.spin === null
                          ? {
                            backgroundColor: colors?.main_buttons,
                            color: "#fff",
                          }
                          : {}
                      }
                      data-type={"AMENIDADES"}
                      data-value={row.name.toUpperCase()}
                    >
                      <div
                        style={
                          isSelected === row.id &&
                            row.menu.length === 0 &&
                            row.spin === null
                            ? {
                              backgroundColor: colors?.main_buttons,
                              color: "#fff",
                            }
                            : {}
                        }
                        data-type={"AMENIDADES"}
                        data-value={row.name.toUpperCase()}
                      >
                        <img
                          src={
                            (window.hybrid
                              ? ""
                              : "https://d1bsymnertnea6.cloudfront.net/") +
                            row.icon
                          }
                          style={
                            isSelected === row.id &&
                              row.menu.length === 0 &&
                              row.spin === null
                              ? {
                                filter: "invert(1) brightness(100%)",
                              }
                              : {}
                          }
                          data-type={"AMENIDADES"}
                          data-value={row.name.toUpperCase()}
                          alt=""
                        />{" "}
                        {row.name}
                        {row.menu.length > 0 || row.spin !== null ? (
                          <i
                            className={`fa fa-chevron-right`}
                            style={{
                              transform:
                                isSelected === row.id
                                  ? "rotate(90deg)"
                                  : "rotate(0deg)",
                            }}
                          ></i>
                        ) : null}
                      </div>
                      {isSelected === row.id && row.menu.length > 0 ? (
                        <div
                          onClick={(event) => {
                            event.stopPropagation(); // Detener la propagación del evento
                            setGaleriaSelected(row.menu);
                            setSubMenuSelected("Galería");
                            setOriginalGleriaSelected(row.menu);
                            setSpinSelected([]);
                          }}
                          className="sidebar-internal-container-menus-subItem"
                          style={{ marginBottom: "0px" }}
                        >
                          <img src="./UI/general/Galeria.svg" alt="" />
                          Ver galería
                        </div>
                      ) : null}
                      {isSelected === row.id && row.spin !== null ? (
                        <div
                          style={
                            isSelected === row.id && subMenuSelected === "Spin"
                              ? {
                                backgroundColor: colors?.main_buttons,
                                color: "#fff",
                                marginBottom: "0px",
                              }
                              : { marginBottom: "0px" }
                          }
                          onClick={(event) => {
                            event.stopPropagation(); // Detener la propagación del evento
                            setSpinSelected(row);
                            setSubMenuSelected("Spin");
                            //setFrame(1);
                          }}
                          className="sidebar-internal-container-menus-subItem"
                        >
                          <img
                            src="./UI/general/Spin180.svg"
                            style={
                              isSelected === row.id && subMenuSelected === "Spin"
                                ? {
                                  filter: "invert(1) brightness(100%)",
                                }
                                : {}
                            }
                            alt=""
                          />
                          Spin
                        </div>
                      ) : null}
                    </div>
                  ))}
                </div>
              ))}
            </>
          ) : menuSelected === "Amenidades" &&
            (subMenuSelected === "" || subMenuSelected === "Spin") && amenities_hierarchical === 0 ? (
            <>
              <div
                className="sidebar-internal-container-menus-item"
                onClick={() => {
                  setIsSelected("");
                  setSpinSelected([]);
                  setSubMenuSelected("");
                  setIsAnimationAmenites(true);
                }}
                style={
                  isSelected === ""
                    ? {
                      backgroundColor: colors?.main_buttons,
                      color: "#fff",
                    }
                    : {}
                }
              >
                <div
                  style={
                    isSelected === ""
                      ? {
                        backgroundColor: colors?.main_buttons,
                        color: "#fff",
                      }
                      : {}
                  }
                >
                  <img
                    src={icon}
                    alt=""
                    style={
                      isSelected === ""
                        ? {
                          filter: "invert(1) brightness(100%)",
                        }
                        : {}
                    }
                  />{" "}
                  {"Ver todos"}
                </div>
              </div>
              {data.map((row) => (
                <div
                  className="sidebar-internal-container-menus-item"
                  onClick={() => {
                    setIsSelected(isSelected === row.id ? "" : row.id);
                    setSpinSelected([]);
                    setSubMenuSelected("");
                    setIsAnimationAmenites(true);
                  }}
                  style={
                    isSelected === row.id &&
                      row.menu.length === 0 &&
                      row.spin === null
                      ? {
                        backgroundColor: colors?.main_buttons,
                        color: "#fff",
                      }
                      : {}
                  }
                  data-type={"AMENIDADES"}
                  data-value={row.name.toUpperCase()}
                >
                  <div
                    style={
                      isSelected === row.id &&
                        row.menu.length === 0 &&
                        row.spin === null
                        ? {
                          backgroundColor: colors?.main_buttons,
                          color: "#fff",
                        }
                        : {}
                    }
                    data-type={"AMENIDADES"}
                    data-value={row.name.toUpperCase()}
                  >
                    <img
                      src={
                        (window.hybrid
                          ? ""
                          : "https://d1bsymnertnea6.cloudfront.net/") +
                        row.icon
                      }
                      style={
                        isSelected === row.id &&
                          row.menu.length === 0 &&
                          row.spin === null
                          ? {
                            filter: "invert(1) brightness(100%)",
                          }
                          : {}
                      }
                      data-type={"AMENIDADES"}
                      data-value={row.name.toUpperCase()}
                      alt=""
                    />{" "}
                    {row.name}
                    {row.menu.length > 0 || row.spin !== null ? (
                      <i
                        className={`fa fa-chevron-right`}
                        style={{
                          transform:
                            isSelected === row.id
                              ? "rotate(90deg)"
                              : "rotate(0deg)",
                        }}
                      ></i>
                    ) : null}
                  </div>
                  {isSelected === row.id && row.menu.length > 0 ? (
                    <div
                      onClick={(event) => {
                        event.stopPropagation(); // Detener la propagación del evento
                        setGaleriaSelected(row.menu);
                        setSubMenuSelected("Galería");
                        setOriginalGleriaSelected(row.menu);
                        setSpinSelected([]);
                      }}
                      className="sidebar-internal-container-menus-subItem"
                      style={{ marginBottom: "0px" }}
                    >
                      <img src="./UI/general/Galeria.svg" alt="" />
                      Ver galería
                    </div>
                  ) : null}
                  {isSelected === row.id && row.spin !== null ? (
                    <div
                      style={
                        isSelected === row.id && subMenuSelected === "Spin"
                          ? {
                            backgroundColor: colors?.main_buttons,
                            color: "#fff",
                            marginBottom: "0px",
                          }
                          : { marginBottom: "0px" }
                      }
                      onClick={(event) => {
                        event.stopPropagation(); // Detener la propagación del evento
                        setSpinSelected(row);
                        setSubMenuSelected("Spin");
                        //setFrame(1);
                      }}
                      className="sidebar-internal-container-menus-subItem"
                    >
                      <img
                        src="./UI/general/Spin180.svg"
                        style={
                          isSelected === row.id && subMenuSelected === "Spin"
                            ? {
                              filter: "invert(1) brightness(100%)",
                            }
                            : {}
                        }
                        alt=""
                      />
                      Spin
                    </div>
                  ) : null}
                </div>
              ))}
            </>
          ) : menuSelected !== "Galería" && subMenuSelected === "Galería" ? (
            original.map((row) => (
              <div
                className="sidebar-internal-container-menus-item"
                onClick={() => {
                  setIsSelected(isSelected === row.name ? "" : row.name);
                  setGaleriaSelected(
                    isSelected === row.name
                      ? original
                      : original?.filter((g) => g.name === row.name)
                  );
                }}
                style={
                  isSelected === row.name
                    ? {
                      backgroundColor: colors?.main_buttons,
                      color: "#fff",
                    }
                    : {}
                }
              >
                <div>
                  <img src={icon} alt="" /> {row.name}
                </div>
              </div>
            ))
          ) : menuSelected === "Galería" &&
            subMenuSelected !== "Galería" &&
            subMenuSelected !== "" ? (
            original
              .find((o) => o.name === subMenuSelected)
              ?.galleries?.galleries[0]?.map((row) => (
                <div
                  className="sidebar-internal-container-menus-item"
                  onClick={() => {
                    setIsSelected(isSelected === row.name ? "" : row.name);
                    setGaleriaSelected(
                      isSelected === row.name
                        ? original.find((o) => o.name === subMenuSelected)
                          ?.galleries?.galleries[0]
                        : original
                          .find((o) => o.name === subMenuSelected)
                          ?.galleries?.galleries[0]?.filter(
                            (g) => g.name === row.name
                          )
                    );
                  }}
                  style={
                    isSelected === row.name
                      ? {
                        backgroundColor: colors?.main_buttons,
                        color: "#fff",
                      }
                      : {}
                  }
                >
                  <div
                    style={
                      isSelected === row.name
                        ? {
                          backgroundColor: colors?.main_buttons,
                          color: "#fff",
                        }
                        : {}
                    }
                  >
                    <img
                      src={icon}
                      alt=""
                      style={
                        isSelected === row.name
                          ? {
                            filter: "invert(1) brightness(100%)",
                          }
                          : {}
                      }
                    />{" "}
                    {row.name}
                  </div>
                </div>
              ))
          ) : menuSelected === "Galería" && subMenuSelected === "Galería" ? (
            data.map((row: any) =>
              row?.galleries?.galleries.length > 0 ? (
                <div
                  className="sidebar-internal-container-menus-folder"
                  onClick={() => {
                    // setIsSelected(isSelected === row.name ? "" : row.name)
                    setSubMenuSelected(row.name);
                    setGaleriaSelected(
                      data.find((g) => g.name === row.name)?.galleries
                        ?.galleries[0]
                    );
                  }}
                  style={
                    isSelected === row.name
                      ? {
                        backgroundColor: colors?.main_buttons,
                        color: "#fff",
                      }
                      : {}
                  }
                >
                  <div
                    style={
                      isSelected === row.name
                        ? {
                          backgroundColor: colors?.main_buttons,
                          color: "#fff",
                        }
                        : {}
                    }
                  >
                    <img
                      src={
                        row.name === "Proyecto"
                          ? "./UI/menu/urbanismo.svg"
                          : (window.hybrid
                            ? "./"
                            : "https://d1bsymnertnea6.cloudfront.net/") +
                          row.background
                      }
                      alt=""
                    />{" "}
                    {row.name}
                  </div>
                </div>
              ) : null
            )
          ) : null}
        </div>
      </div>
      <div
        className={`side-bar-toggle ${theme} ${menuSelected}`}
        onClick={() => setIsSideBar(!isSideBar)}
      >
        <i
          className={`fa-solid ${isSideBar ? "fa-chevron-left" : "fa-chevron-right"
            }`}
        ></i>
      </div>
    </div>
  ) : (
    <div className={`sidebar-container-portrait`}>
      <div
        className={`sidebar-container-portrait-internal ${theme}  ${menuSelected}`}
        style={
          (Array.isArray(data) && data.find((e) => e.id === isSelected))?.id ||
            (original && original.find((e) => e.name === isSelectedGallerieGroup))
              ?.name ||
            isSelectedLocationGroup !== ""
            ? { maxHeight: "11.4375rem" }
            : menuSelected === "Inmuebles" || (menuSelected === "Amenidades" && amenities_hierarchical === 1 && subMenuSelected !== "Galería")
              ? { maxHeight: "17.6875rem" }
              : {}
        }
      >
        <div
          onTouchStart={(e) => {
            setIsDragging(true);
            setStartX(window.innerHeight - e.touches[0].clientY);
            console.log("a", window.innerHeight - e.touches[0].clientY);
          }}
          onTouchMove={(e) => {
            console.log("ac", window.innerHeight - e.touches[0].clientY);

            var sidebarOriginal: any = document.querySelector(
              ".sidebar-container-portrait"
            );
            var sidebarInternal: any = document.querySelector(
              ".sidebar-container-portrait-internal"
            );
            console.log(sidebarInternal.offsetHeight);

            if (isDragging) {
              const diffX = window.innerHeight - e.touches[0].clientY;
              console.log(isSideBar);

              if (isSideBar) {
                if (diffX <= startX && diffX >= 14) {
                  const newWidth = diffX - sidebarInternal.offsetHeight;
                  sidebarOriginal.style.bottom = `${newWidth}px`;
                  setStartX(window.innerHeight - e.touches[0].clientY);
                  setStartXOther(window.innerHeight - e.touches[0].clientY);
                }
              } else {
                if (diffX >= startX && diffX <= sidebarInternal.offsetHeight) {
                  const newWidth = diffX - sidebarInternal.offsetHeight;
                  sidebarOriginal.style.bottom = `${newWidth}px`;
                  setStartX(window.innerHeight - e.touches[0].clientY);
                  setStartXOther(window.innerHeight - e.touches[0].clientY);
                }
              }
            }
          }}
          onTouchEnd={(e) => {
            var sidebarInternal: any = document.querySelector(
              ".sidebar-container-portrait-internal"
            );
            console.log();

            if (startXOther !== null) {
              if (startX < sidebarInternal.offsetHeight / 2) {
                setIsSideBar(false);
                handleAddDown(false);
                setStartXOther(null);
              } else {
                setIsSideBar(true);
                handleAddDown(true);
                setStartXOther(null);
              }
            }
          }}
        >
          <div
            className={`sidebar-toggle-internal ${theme}`}
            //onClick={() => setIsSideBar(!isSideBar)}
            onTouchStart={(e) => {
              setIsDragging(true);
              setStartX(window.innerHeight - e.touches[0].clientY);
              console.log("a", window.innerHeight - e.touches[0].clientY);
            }}
            onTouchMove={(e) => {
              console.log("ac", window.innerHeight - e.touches[0].clientY);

              var sidebarOriginal: any = document.querySelector(
                ".sidebar-container-portrait"
              );
              var sidebarInternal: any = document.querySelector(
                ".sidebar-container-portrait-internal"
              );
              console.log(sidebarInternal.offsetHeight);

              if (isDragging) {
                const diffX = window.innerHeight - e.touches[0].clientY;
                console.log(isSideBar);

                if (isSideBar) {
                  if (diffX <= startX && diffX >= 14) {
                    const newWidth = diffX - sidebarInternal.offsetHeight;
                    sidebarOriginal.style.bottom = `${newWidth}px`;
                    setStartX(window.innerHeight - e.touches[0].clientY);
                    setStartXOther(window.innerHeight - e.touches[0].clientY);
                  }
                } else {
                  if (
                    diffX >= startX &&
                    diffX <= sidebarInternal.offsetHeight
                  ) {
                    const newWidth = diffX - sidebarInternal.offsetHeight;
                    sidebarOriginal.style.bottom = `${newWidth}px`;
                    setStartX(window.innerHeight - e.touches[0].clientY);
                    setStartXOther(window.innerHeight - e.touches[0].clientY);
                  }
                }
              }
            }}
            onTouchEnd={(e) => {
              var sidebarInternal: any = document.querySelector(
                ".sidebar-container-portrait-internal"
              );
              console.log();

              if (startXOther !== null) {
                if (startX < sidebarInternal.offsetHeight / 2) {
                  setIsSideBar(false);
                  handleAddDown(false);
                  setStartXOther(null);
                } else {
                  setIsSideBar(true);
                  handleAddDown(true);
                  setStartXOther(null);
                }
              }
            }}
          ></div>
        </div>
        <div className="sidebar-title-internal-portrait">
          <img src={icono} alt="" />
          {menuSelected !== "Galería" && subMenuSelected === "Galería"
            ? subMenuSelected
            : menuSelected}
        </div>
        <div className={`sidebar-menu-container-portrait ${theme}`}>
          {menuSelected === "Urbanismo" && subMenuSelected === "" ? (
            data
              .sort((a, b) =>
                !a.hierarchicalLevel
                  ? 1
                  : !b.hierarchicalLevel
                    ? -1
                    : parseInt(b.hierarchicalLevel.split("#")[1]) -
                    parseInt(a.hierarchicalLevel.split("#")[1])
              )
              .map((row) =>
                row.type === "Hierarchical" ? (
                  <div
                    className="sidebar-menu-container-portrait-menus-item"
                    onClick={() =>
                      setIsSelected(isSelected === row.name ? "" : row.name)
                    }
                    style={
                      isSelected === row.name
                        ? {
                          backgroundColor: colors?.main_buttons,
                          color: "#fff",
                        }
                        : {}
                    }
                  >
                    <div>
                      <img src={icon} alt="" /> {row.name}
                    </div>
                  </div>
                ) : null
              )
          ) : menuSelected === "Ubicación" ? (
            <>
              {data?.routes?.length > 0 ||
                data?.mapa_ilustrado_vias !== null ? (
                <div
                  className="sidebar-menu-container-portrait-menus-item"
                  onClick={() =>
                    setIsSelectedLocationGroup(
                      isSelectedLocationGroup === "vias" ? "" : "vias"
                    )
                  }
                  style={
                    isSelectedLocationGroup === "vias"
                      ? {
                        backgroundColor: colors?.main_buttons,
                        color: "#fff",
                      }
                      : {}
                  }
                >
                  <div>
                    <img src={VIA} alt="" /> Vías de Acceso
                  </div>
                </div>
              ) : null}
              {data?.POIS?.length > 0 || data?.mapa_ilustrado_pois !== null ? (
                <div
                  className="sidebar-menu-container-portrait-menus-item"
                  onClick={() =>
                    setIsSelectedLocationGroup(
                      isSelectedLocationGroup === "poi" ? "" : "poi"
                    )
                  }
                  style={
                    isSelectedLocationGroup === "poi"
                      ? {
                        backgroundColor: colors?.main_buttons,
                        color: "#fff",
                      }
                      : {}
                  }
                >
                  <div>
                    <img src={POI} alt="" /> Puntos de interés
                  </div>
                </div>
              ) : null}
            </>
          ) : menuSelected === "Amenidades" && subMenuSelected !== "Galería" && amenities_hierarchical === 0 ? (
            <>
              <div
                className="sidebar-menu-container-portrait-menus-item"
                onClick={() => setIsSelected("")}
                style={
                  isSelected === ""
                    ? {
                      backgroundColor: colors?.main_buttons,
                      color: "#fff",
                      width: "4.625rem",
                      minWidth: "4.625rem",
                    }
                    : {
                      width: "4.625rem",
                      minWidth: "4.625rem",
                    }
                }
              >
                <div>{"Ver todos"}</div>
              </div>
              {data.map((row) => (
                <div
                  className="sidebar-menu-container-portrait-menus-item"
                  onClick={() => {
                    setIsSelected(isSelected === row.id ? "" : row.id);
                    setSpinSelected([]);
                    setSubMenuSelected("");
                    setIsAnimationAmenites(true);
                  }}
                  style={
                    isSelected === row?.id
                      ? {
                        backgroundColor: colors?.main_buttons,
                        color: "#fff",
                        width:
                          row.name.length <= 10
                            ? "7.75rem"
                            : row.name.length > 10 && row.name.length < 18
                              ? "10.75rem"
                              : row.name.length > 18
                                ? "13.375rem"
                                : "4.625rem",
                        minWidth:
                          row.name.length <= 10
                            ? "7.75rem"
                            : row.name.length > 10 && row.name.length < 18
                              ? "10.75rem"
                              : row.name.length > 18
                                ? "13.375rem"
                                : "4.625rem",
                      }
                      : {
                        width:
                          row.name.length <= 10
                            ? "7.75rem"
                            : row.name.length > 10 && row.name.length < 18
                              ? "10.75rem"
                              : row.name.length > 18
                                ? "13.375rem"
                                : "4.625rem",
                        minWidth:
                          row.name.length <= 10
                            ? "7.75rem"
                            : row.name.length > 10 && row.name.length < 18
                              ? "10.75rem"
                              : row.name.length > 18
                                ? "13.375rem"
                                : "4.625rem",
                      }
                  }
                  data-type={"AMENIDADES"}
                  data-value={row.name.toUpperCase()}
                >
                  <div
                    data-type={"AMENIDADES"}
                    data-value={row.name.toUpperCase()}
                  >
                    <img
                      src={
                        (window.hybrid
                          ? "./"
                          : "https://d1bsymnertnea6.cloudfront.net/") +
                        row.icon
                      }
                      alt=""
                      data-type={"AMENIDADES"}
                      data-value={row.name.toUpperCase()}
                    />{" "}
                    {row.name}
                    {/* {row.menu.length > 0 ? (
                      <i
                        className={`fa fa-chevron-${
                          isSelected === row.id ? "down" : "right"
                        }`}
                      ></i>
                    ) : null} */}
                  </div>
                </div>
              ))}
            </>
          ) : menuSelected === "Amenidades" && subMenuSelected !== "Galería" && amenities_hierarchical === 1 ? (
            <>
              <div
                className="sidebar-menu-container-portrait-menus-item"
                onClick={() => {setIsSelected(""), setIsSelectedAmenitiesAttributes([]), setIsSelectedAmenityAttributeIndividual("")}}
                style={
                  isSelected === ""
                    ? {
                      backgroundColor: colors?.main_buttons,
                      color: "#fff",
                      width: "4.625rem",
                      minWidth: "4.625rem",
                    }
                    : {
                      width: "4.625rem",
                      minWidth: "4.625rem",
                    }
                }
              >
                <div>{"Ver todos"}</div>
              </div>
              {data.map((row) => (
                <div
                  className="sidebar-menu-container-portrait-menus-item"
                  onClick={() => {
                    setIsSelectedAmenityAttributeIndividual(isSelectedAmenityAttributeIndividual === row.attribute_id ? "" : row.attribute_id);
                    setSpinSelected([]);
                    setSubMenuSelected("");
                    setIsAnimationAmenites(true);
                    setIsSelectedAmenitiesAttributes(row.amenities)
                  }}
                  style={
                    isSelectedAmenityAttributeIndividual === row?.attribute_id
                      ? {
                        backgroundColor: colors?.main_buttons,
                        color: "#fff",
                        width:
                          row.attribute.length <= 10
                            ? "7.75rem"
                            : row.attribute.length > 10 && row.attribute.length < 18
                              ? "10.75rem"
                              : row.attribute.length > 18
                                ? "13.375rem"
                                : "4.625rem",
                        minWidth:
                          row.attribute.length <= 10
                            ? "7.75rem"
                            : row.attribute.length > 10 && row.attribute.length < 18
                              ? "10.75rem"
                              : row.attribute.length > 18
                                ? "13.375rem"
                                : "4.625rem",
                      }
                      : {
                        width:
                          row.attribute.length <= 10
                            ? "7.75rem"
                            : row.attribute.length > 10 && row.attribute.length < 18
                              ? "10.75rem"
                              : row.attribute.length > 18
                                ? "13.375rem"
                                : "4.625rem",
                        minWidth:
                          row.attribute.length <= 10
                            ? "7.75rem"
                            : row.attribute.length > 10 && row.attribute.length < 18
                              ? "10.75rem"
                              : row.attribute.length > 18
                                ? "13.375rem"
                                : "4.625rem",
                      }
                  }
                >
                  <div
                  >
                    {row.attribute}
                  </div>
                </div>
              ))}
            </>
          ) : menuSelected === "Galería" && subMenuSelected === "Galería" ? (
            data.map((row) =>
              row?.galleries?.galleries.length > 0 ? (
                <div
                  className="sidebar-menu-container-portrait-menus-item"
                  onClick={() => {
                    setIsSelectedGallerieGroup(
                      isSelectedGallerieGroup === row.name ? "" : row.name
                    );
                    setSubMenuSelected(row.name);
                    setGaleriaSelected(
                      data.find((g) => g.name === row.name)?.galleries
                        ?.galleries[0]
                    );
                  }}
                  style={
                    isSelectedGallerieGroup === row?.name
                      ? {
                        backgroundColor: colors?.main_buttons,
                        color: "#fff",
                        width: "6.25rem",
                        maxWidth: "6.25rem",
                        minWidth: "6.25rem",
                        height: "1.875rem",
                      }
                      : {
                        width: "6.25rem",
                        minWidth: "6.25rem",
                        maxWidth: "6.25rem",
                        height: "1.875rem",
                      }
                  }
                >
                  <div>{row.name}</div>
                </div>
              ) : null
            )
          ) : null}
        </div>
        <div className={`sidebar-menu-container-portrait ${theme}`}>
          {menuSelected === "Amenidades" && subMenuSelected !== "Galería" && amenities_hierarchical === 1 && isSelectedAmenityAttributeIndividual !== "" ? (
            <>
              <div
                className="sidebar-menu-container-portrait-menus-item"
                onClick={() => setIsSelected("")}
                style={
                  isSelected === ""
                    ? {
                      backgroundColor: colors?.main_buttons,
                      color: "#fff",
                      width: "4.625rem",
                      minWidth: "4.625rem",
                    }
                    : {
                      width: "4.625rem",
                      minWidth: "4.625rem",
                    }
                }
              >
                <div>{"Ver todos"}</div>
              </div>
              {isSelectedAmenitiesAttributes.map((row) => (
                <div
                  className="sidebar-menu-container-portrait-menus-item"
                  onClick={() => {
                    setIsSelected(isSelected === row.id ? "" : row.id);
                    setSpinSelected([]);
                    setSubMenuSelected("");
                    setIsAnimationAmenites(true);
                  }}
                  style={
                    isSelected === row?.id
                      ? {
                        backgroundColor: colors?.main_buttons,
                        color: "#fff",
                        width:
                          row.name.length <= 10
                            ? "7.75rem"
                            : row.name.length > 10 && row.name.length < 18
                              ? "10.75rem"
                              : row.name.length > 18
                                ? "13.375rem"
                                : "4.625rem",
                        minWidth:
                          row.name.length <= 10
                            ? "7.75rem"
                            : row.name.length > 10 && row.name.length < 18
                              ? "10.75rem"
                              : row.name.length > 18
                                ? "13.375rem"
                                : "4.625rem",
                      }
                      : {
                        width:
                          row.name.length <= 10
                            ? "7.75rem"
                            : row.name.length > 10 && row.name.length < 18
                              ? "10.75rem"
                              : row.name.length > 18
                                ? "13.375rem"
                                : "4.625rem",
                        minWidth:
                          row.name.length <= 10
                            ? "7.75rem"
                            : row.name.length > 10 && row.name.length < 18
                              ? "10.75rem"
                              : row.name.length > 18
                                ? "13.375rem"
                                : "4.625rem",
                      }
                  }
                  data-type={"AMENIDADES"}
                  data-value={row.name.toUpperCase()}
                >
                  <div
                    data-type={"AMENIDADES"}
                    data-value={row.name.toUpperCase()}
                  >
                    <img
                      src={
                        (window.hybrid
                          ? "./"
                          : "https://d1bsymnertnea6.cloudfront.net/") +
                        row.icon
                      }
                      alt=""
                      data-type={"AMENIDADES"}
                      data-value={row.name.toUpperCase()}
                    />{" "}
                    {row.name}
                    {/* {row.menu.length > 0 ? (
                      <i
                        className={`fa fa-chevron-${
                          isSelected === row.id ? "down" : "right"
                        }`}
                      ></i>
                    ) : null} */}
                  </div>
                </div>
              ))}
            </>
          ) : null}
        </div>
        <div className={`sidebar-menu-container-portrait ${theme}`}>
          {menuSelected === "Amenidades" &&
            subMenuSelected === "" &&
            isSelected !== "" &&
            data.find((e) => e.id === isSelected)?.menu?.length > 0 ? (
            <div
              className="sidebar-menu-container-portrait-menus-item"
              onClick={(event) => {
                event.stopPropagation(); // Detener la propagación del evento
                setGaleriaSelected(data.find((e) => e.id === isSelected)?.menu);
                setSubMenuSelected("Galería");
                setOriginalGleriaSelected(
                  data.find((e) => e.id === isSelected)?.menu
                );
                setSpinSelected([]);
              }}
            /* style={
              isSelected === data.find((e) => e.id === isSelected)?.id
                ? {
                    backgroundColor: colors?.main_buttons,
                    color: "#fff",
                  }
                : {}
            } */
            >
              <div>
                <img src={icon} alt="" /> {"Ver galería"}
              </div>
            </div>
          ) : null}{" "}
          {menuSelected === "Amenidades" &&
            //subMenuSelected !== "" &&
            isSelected !== "" &&
            data.find((e) => e.id === isSelected)?.spin !== null ? (
            <div
              className="sidebar-menu-container-portrait-menus-item"
              style={
                isSelected === data.find((e) => e.id === isSelected)?.id &&
                  subMenuSelected === "Spin"
                  ? {
                    backgroundColor: colors?.main_buttons,
                    color: "#fff",
                  }
                  : {}
              }
              onClick={(event) => {
                event.stopPropagation(); // Detener la propagación del evento
                setSpinSelected(data.find((e) => e.id === isSelected));
                setSubMenuSelected("Spin");
                //setFrame(1);
              }}
            >
              <div>
                <img src={icon} alt="" /> {"Spin"}
              </div>
            </div>
          ) : null}
        </div>
        {menuSelected === "Galería" &&
          subMenuSelected !== "" &&
          isSelectedGallerieGroup !== "" &&
          data?.length > 0 ? (
          <>
            <div className={`sidebar-menu-container-portrait ${theme}`}>
              {original.map((row) => (
                <div
                  className="sidebar-menu-container-portrait-menus-item"
                  onClick={() => {
                    setIsSelectedGallerieGroup(
                      isSelectedGallerieGroup === row?.name ? "" : row?.name
                    );
                    setSubMenuSelected(
                      isSelectedGallerieGroup === row?.name
                        ? "Galería"
                        : row?.name
                    );
                    setIsSelected("");
                    setGaleriaSelected(
                      isSelectedGallerieGroup === row?.name
                        ? original
                        : original.find((g) => g.name === row?.name)?.galleries
                          ?.galleries[0]
                    );
                  }}
                  style={
                    isSelectedGallerieGroup === row?.name
                      ? {
                        backgroundColor: colors?.main_buttons,
                        color: "#fff",
                        width: "6.25rem",
                        maxWidth: "6.25rem",
                        minWidth: "6.25rem",
                        height: "1.875rem",
                      }
                      : {
                        width: "6.25rem",
                        minWidth: "6.25rem",
                        maxWidth: "6.25rem",
                        height: "1.875rem",
                      }
                  }
                >
                  <div>{row?.name}</div>
                </div>
              ))}
            </div>
            <div className={`sidebar-menu-container-portrait ${theme}`}>
              {original
                .find((g) => g.name === isSelectedGallerieGroup)
                ?.galleries?.galleries[0].map((row) => (
                  <div
                    className="sidebar-menu-container-portrait-menus-item"
                    onClick={() => {
                      setIsSelected(isSelected === row.name ? "" : row.name);
                      setGaleriaSelected(
                        isSelected === row.name
                          ? original.find((o) => o.name === subMenuSelected)
                            ?.galleries?.galleries[0]
                          : original
                            .find((o) => o.name === subMenuSelected)
                            ?.galleries?.galleries[0]?.filter(
                              (g) => g.name === row.name
                            )
                      );
                    }}
                    style={
                      isSelected === row?.name
                        ? {
                          backgroundColor: colors?.main_buttons,
                          color: "#fff",
                          width: "6.25rem",
                          maxWidth: "6.25rem",
                          minWidth: "6.25rem",
                          height: "1.875rem",
                        }
                        : {
                          width: "6.25rem",
                          minWidth: "6.25rem",
                          maxWidth: "6.25rem",
                          height: "1.875rem",
                        }
                    }
                  >
                    <div>{row.name}</div>
                  </div>
                ))}
            </div>
          </>
        ) : null}{" "}
        {menuSelected === "Ubicación" && isSelectedLocationGroup !== "" ? (
          <div className="sidebar-menu-container-location-portrait">
            {isSelectedLocationGroup === "vias" ? (
              <div className="sidebar-menu-container-location-portrait-container-item">
                {data?.routes?.length > 0
                  ? data?.routes?.map((e) => (
                    <div
                      className="sidebar-menu-container-location-portrait-item"
                      style={
                        isSelectedVIA.length === 1 &&
                          isSelectedVIA[0]?.name === e.name
                          ? { backgroundColor: colors?.main_buttons }
                          : {}
                      }
                      data-type={"UBICACION"}
                      data-value={"VIA"}
                      data-second={e.name.toUpperCase()}
                      onClick={() => {
                        setIsSelectedVIA([e]), setIsSelectedPOI([]);
                      }}
                    >
                      <div style={{ backgroundColor: e.color }}></div>
                      <span>{e.name}</span>
                    </div>
                  ))
                  : null}
              </div>
            ) : isSelectedLocationGroup === "poi" ? (
              <div className="sidebar-menu-container-location-portrait-container-item">
                {data?.POIS?.length > 0
                  ? data?.POIS?.map((e) => (
                    <div
                      className="sidebar-menu-container-location-portrait-item"
                      style={
                        isSelectedPOI.length === 1 &&
                          isSelectedPOI[0]?.category === e.category
                          ? { backgroundColor: colors?.main_buttons }
                          : {}
                      }
                      data-type={"UBICACION"}
                      data-value={"POI"}
                      data-second={e.category.toUpperCase()}
                      onClick={() => {
                        setIsSelectedPOI([e]), setIsSelectedVIA([]);
                      }}
                    >
                      <img
                        style={
                          isSelectedPOI.length === 1 &&
                            isSelectedPOI[0]?.category === e.category
                            ? { filter: "invert(1) brightness(100%)" }
                            : { filter: "invert(1) brightness(100%)" }
                        }
                        src={
                          (window.hybrid
                            ? "./"
                            : "https://d1bsymnertnea6.cloudfront.net/") +
                          e.icon
                        }
                        alt=""
                      />
                      <span>{e.category}</span>
                    </div>
                  ))
                  : null}
              </div>
            ) : null}
          </div>
        ) : null}
        {menuSelected === "Inmuebles" &&
          subMenuSelected !== "Galería" &&
          data?.properties?.disponibilidad ? (
          <div className="sidebar-menu-container-property-portrait">
            <div
              className="sidebar-menu-container-property-portrait-title"
              onClick={() =>
                setIsSelectedModulAttribute({
                  ...isSelectedModulAttribute,
                  disponibilidad: !isSelectedModulAttribute.disponibilidad,
                })
              }
            >
              DISPONIBILIDAD
              <i
                className={`fa fa-chevron-${isSelectedModulAttribute.disponibilidad ? "down" : "right"
                  }`}
              ></i>
            </div>
            {isSelectedModulAttribute.disponibilidad ? (
              <div className="sidebar-menu-container-property-portrait-container-item">
                {data?.state_disponible ? (
                  <div className="sidebar-menu-container-property-portrait-item-availability">
                    <span>Disponible</span>
                    <FormControlLabel
                      control={
                        <SwitchDisponible sx={{ m: 1 }} defaultChecked />
                      }
                      label=""
                      onChange={(e: any) =>
                        setSelectAvailability({
                          ...selectAvailability,
                          DISPONIBLE: e.target.checked,
                        })
                      }
                    />
                  </div>
                ) : null}

                {data?.state_disponible ? (
                  <div className="sidebar-menu-container-property-portrait-item-availability">
                    <span>Vendido</span>
                    <FormControlLabel
                      control={<SwitchVendido sx={{ m: 1 }} defaultChecked />}
                      label=""
                      onChange={(e: any) =>
                        setSelectAvailability({
                          ...selectAvailability,
                          VENDIDO: e.target.checked,
                        })
                      }
                    />
                  </div>
                ) : null}

                {data?.state_disponible ? (
                  <div className="sidebar-menu-container-property-portrait-item-availability">
                    <span>Reservado</span>
                    <FormControlLabel
                      control={<SwitchReservado sx={{ m: 1 }} defaultChecked />}
                      label=""
                      onChange={(e: any) =>
                        setSelectAvailability({
                          ...selectAvailability,
                          RESERVADO: e.target.checked,
                        })
                      }
                    />
                  </div>
                ) : null}

                {data?.state_disponible ? (
                  <div className="sidebar-menu-container-property-portrait-item-availability">
                    <span>No Disponible</span>
                    <FormControlLabel
                      control={
                        <SwitchNoDisponible sx={{ m: 1 }} defaultChecked />
                      }
                      label=""
                      onChange={(e: any) =>
                        setSelectAvailability({
                          ...selectAvailability,
                          "NO DISPONIBLE": e.target.checked,
                        })
                      }
                    />
                  </div>
                ) : null}
              </div>
            ) : null}
          </div>
        ) : null}
        {menuSelected === "Inmuebles" && subMenuSelected === "" ? (
          <div className="sidebar-menu-container-property-portrait">
            <div
              className="sidebar-menu-container-property-portrait-title"
              onClick={() =>
                setIsSelectedModulAttribute({
                  ...isSelectedModulAttribute,
                  filtros: !isSelectedModulAttribute.filtros,
                })
              }
            >
              FILTRAR POR ATRIBUTOS
              <i
                className={`fa fa-chevron-${isSelectedModulAttribute.disponibilidad ? "down" : "right"
                  }`}
              ></i>
            </div>
            {isSelectedModulAttribute.filtros ? (
              <div className="sidebar-menu-container-property-portrait-container-item">
                {data?.properties?.attributes?.map((row, ind) =>
                  row.active ? (
                    <div className="sidebar-menu-container-property-portrait-item-filter">
                      <span>{row.name}</span>
                      <select
                        name="cars"
                        id="cars"
                        style={{
                          backgroundColor: colors?.main_buttons,
                          color: "#fff",
                        }}
                        onChange={(e) => {
                          if (e.target.value === "Ver todos") {
                            setIsSelectedAttribute({
                              ...isSelectedAttribute,
                              [row.name]: {},
                            });
                            setCurrentSelectedAttribute({})
                            setIsAnimationAttribute(true)
                          } else {
                            setIsSelectedAttribute({
                              ...isSelectedAttribute,
                              [row.name]: JSON.parse(e.target.value),
                            });
                            setCurrentSelectedAttribute(JSON.parse(e.target.value))
                            setIsAnimationAttribute(true)
                          }
                        }}
                      >
                        <option value="Ver todos">Ver todos</option>
                        {row?.values?.map((subRow, subInd) =>
                          isValidateFilter(subRow) ? (
                            <option
                              value={JSON.stringify(subRow)}
                              data-type={"FILTRO"}
                              data-second={row.name}
                              data-value={subRow.value.toUpperCase()}
                            >
                              {subRow.value}
                            </option>
                          ) : null
                        )}
                      </select>
                    </div>
                  ) : null
                )}
              </div>
            ) : null}
          </div>
        ) : null}
        {menuSelected === "Inmuebles" &&
          subMenuSelected !== "" &&
          subMenuSelected !== "Galería" ? (
          <div className="sidebar-menu-container-property-portrait">
            <div
              className="sidebar-menu-container-property-portrait-title"
              onClick={() =>
                setIsSelectedModulAttribute({
                  ...isSelectedModulAttribute,
                  filtros: !isSelectedModulAttribute.filtros,
                })
              }
            >
              FILTRAR POR ATRIBUTOS
              <i
                className={`fa fa-chevron-${isSelectedModulAttribute.disponibilidad ? "down" : "right"
                  }`}
              ></i>
            </div>
            {isSelectedModulAttribute.filtros ? (
              <div className="sidebar-menu-container-property-portrait-container-item">
                {data?.properties?.attributes?.map((row, ind) =>
                  row.active ? (
                    <div className="sidebar-menu-container-property-portrait-item-filter">
                      <span>{row.name}</span>
                      <select
                        name="cars"
                        id="cars"
                        style={{
                          backgroundColor: colors?.main_buttons,
                          color: "#fff",
                        }}
                        onChange={(e) => {
                          if (e.target.value === "Ver todos") {
                            setIsSelectedAttribute({
                              ...isSelectedAttribute,
                              [row.name]: {},
                            });
                            setCurrentSelectedAttribute({})
                            setIsAnimationAttribute(true)
                          } else {
                            setIsSelectedAttribute({
                              ...isSelectedAttribute,
                              [row.name]: JSON.parse(e.target.value),
                            });
                            setCurrentSelectedAttribute(JSON.parse(e.target.value))
                            setIsAnimationAttribute(true)
                          }
                        }}
                      >
                        <option value="Ver todos">Ver todos</option>
                        {row?.values?.map((subRow, subInd) =>
                          isValidateFilter(subRow) ? (
                            <option
                              value={JSON.stringify(subRow)}
                              data-type={"FILTRO"}
                              data-second={row.name}
                              data-value={subRow.value.toUpperCase()}
                            >
                              {subRow.value}
                            </option>
                          ) : null
                        )}
                      </select>
                    </div>
                  ) : null
                )}
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
      <div className={`sidebar-container-portrait-close  ${theme}`}>
        <div
          className="setting-boton-circular"
          onClick={() => {
            if (menuSelected === "Inmuebles" && subMenuSelected === "Galería") {
              setSubMenuSelected(subMenuSelectedTemp);
            } else if (
              menuSelected !== "Galería" &&
              menuSelected !== "Inmuebles" &&
              subMenuSelected === "Galería"
            ) {
              setSubMenuSelected("");
            } else {
              setMenuSelected("");
            }

            setSubMenuSelected("");
            setGaleriaSelected([]);
            // setFrame(1);
          }}
        >
          <i className="fas fa-xmark"></i>
        </div>
      </div>
    </div>
  );
}
